<div class="routing-group-panel">
  <div class="routing-group-list">
    <virtual-scroller cdkDropList (cdkDropListDropped)="drop($event, scroll.viewPortInfo)"
                      #scroll [items]="groups" checkResizeInterval="100"
                      [enableUnequalChildrenSizes]="true" class="group-virtual-scroll">
      <div class="routing-group-item" (cdkDragStarted)="onDrag()" *ngFor="let group of scroll.viewPortItems"
           cdkDrag (click)="selectGroup(group)" [ngClass]="{'selected': isSelected(group), 'is-filtered' : group.isFiltered}">
        <div class="routing-group-container">
          <span cdkDragHandle class="material-icons move-item">drag_indicator</span>
          <div class="routing-group-heading-container">
            <div class="routing-group-title-container">
              <span class="routing-group-title" [title]="group.name">
                <i [ngClass]="{'fa fa-calendar-check-o tbr-padding' : group.tbrConditionsIds && group.tbrConditionsIds.length !== 0,
                'rg-title-padding': !group.tbrConditionsIds || group.tbrConditionsIds.length === 0}">
                </i>
                {{group.name}} ({{group.routingRules.length}})
              </span>
            </div>
          </div>
          <span cdkDragHandle class="material-icons group-options" [matMenuTriggerFor]="groupMenu">more_vert</span>
          <mat-menu #groupMenu="matMenu">
            <button mat-menu-item (click)="this.onDeleteGroup($event, group)">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
            <button mat-menu-item (click)="this.onEditGroup($event, group)">
              <mat-icon>create</mat-icon>
              <span>Edit</span>
            </button>
            <button mat-menu-item (click)="this.onMoveGroup($event, group)">
              <mat-icon>open_with</mat-icon>
              <span>Move</span>
            </button>
          </mat-menu>
          <div *cdkDragPreview></div>
        </div>
      </div>
    </virtual-scroller>
  </div>
</div>
